<template>
    <div class="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 auto-rows-fr gap-4 mb-8">
        <slot></slot>
    </div>
</template>